import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { TrafficAccessRulesKeyEnum } from './traffic-access-rules-key.enum';
import { TrafficAccessRulesConst } from './traffic-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class TrafficAccessService extends BaseAccessService<TrafficAccessRulesKeyEnum> {
  public constructor() {
    super(TrafficAccessRulesConst);
  }

  public get trafficRights() {
    return {
      canReadAdapter: this.globalService.isAccessRule(
        TrafficAccessRulesConst[TrafficAccessRulesKeyEnum.TRAFFIC_TRAFFIC_ADAPTER_READ]
      ),
      canWriteAdapter: this.globalService.isAccessRule(
        TrafficAccessRulesConst[TrafficAccessRulesKeyEnum.TRAFFIC_TRAFFIC_ADAPTER_WRITE]
      ),

      canReadTraffic: this.globalService.isAccessRule(
        TrafficAccessRulesConst[TrafficAccessRulesKeyEnum.TRAFFIC_TRAFFIC_REPORT_READ]
      )
    };
  }
}
